<!-- <app-spinner *ngIf="load" [loading]="load" [fullScreen]="true" [text]="''"></app-spinner> -->


<!-- <app-spinner *ngIf="loading" [loading]="loading" [text]="loadingMessage" [fullScreen]="true"></app-spinner> -->


<app-spinner
  *ngIf="loading"
  [loading]="loading"
  [text]="loadingMessage"
  [fullScreen]="true"
></app-spinner>

<div
  class="create-app-backdrop"
  *ngIf="!loading"
  (click)="closeModal()"
>
  <section
    class="create-app-modal"
    (click)="$event.stopPropagation()"
  >
    <header class="create-app-modal__header">
      <div>
        <span>NEW RESTAURANT</span>
        <h2>ახალი რესტორნის შექმნა</h2>
        <p>აირჩიე უნიკალური Menuload მისამართი.</p>
      </div>

      <button
        type="button"
        class="create-app-modal__close"
        (click)="closeModal()"
      >
        ×
      </button>
    </header>

    <div class="create-app-modal__body">
      <label for="restaurant-domain">
        რესტორნის მისამართი
      </label>

      <div
        class="domain-input"
        [class.domain-input--invalid]="
          domain.length > 0 && !isDomainValid
        "
      >
        <input
          id="restaurant-domain"
          type="text"
          name="domain"
          [(ngModel)]="domain"
          (ngModelChange)="normalizeDomain($event)"
          placeholder="მაგალითად: toka"
          maxlength="40"
          autocomplete="off"
        >

        <span>.menuload.com</span>
      </div>

      <small
        class="domain-hint"
        *ngIf="!domain"
      >
        გამოიყენე მხოლოდ ინგლისური ასოები და ციფრები.
      </small>

      <small
        class="domain-error"
        *ngIf="domain && !isDomainValid"
      >
        მისამართი უნდა შეიცავდეს მხოლოდ პატარა ინგლისურ ასოებსა და
        ციფრებს.
      </small>

      <div
        class="domain-preview"
        *ngIf="domain && isDomainValid"
      >
        <span>შენი მისამართი იქნება:</span>

        <strong>
          https://{{ domain }}.menuload.com
        </strong>
      </div>

      <div class="create-app-modal__field">
        <label for="business-type">
          ბიზნესის ტიპი
        </label>

        <select
          id="business-type"
          name="business_type"
          [(ngModel)]="business_type"
        >
          <option value="restaurant">რესტორანი</option>
          <option value="hotel">სასტუმრო</option>
          <option value="cafe">კაფე</option>
          <option value="bar">ბარი</option>
        </select>
      </div>

      <div class="create-app-modal__field">
        <label for="duration">
          ხანგრძლივობა
        </label>

        <select
          id="duration"
          name="duration"
          [ngModel]="form.get('duration')?.value"
          (ngModelChange)="
            form.get('duration')?.setValue($event)
          "
        >
          <option value="1">1 თვე</option>
          <option value="3">3 თვე</option>
          <option value="6">6 თვე</option>
          <option value="12">12 თვე</option>
        </select>
      </div>
    </div>

    <footer class="create-app-modal__footer">
      <button
        type="button"
        class="create-app-modal__cancel"
        [disabled]="loading"
        (click)="closeModal()"
      >
        გაუქმება
      </button>

      <button
        type="button"
        class="create-app-modal__submit"
        [disabled]="loading || !isDomainValid"
        (click)="create('20')"
      >
        <span>რესტორნის შექმნა</span>
        <i class="fi fi-rr-arrow-small-right"></i>
      </button>
    </footer>
  </section>
</div>
